module.exports = __webpack_public_path__ + "static/img/quanping.1ec27458.png";